import { USER } from '../constant/actionTypes';
import { constants } from '../constant/constant';

const getUserRoles = (role = 'superadmin') => (dispatch) => {
  /**
   * USER Roles has been moved from system
   */
  let modules = [
    {
      moduleName: 'client',
      create: true,
      read: true,
      update: true,
      delete: true,
      lock: true,
    },
    {
      moduleName: 'clientUser',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'clientDomain',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'software',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'whiteListedIp',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'licenseManagement',
      read: true,
    },
    {
      moduleName: 'licenseInstance',
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'licenseGenerate',
      create: true,
      read: true,
      update: true,
      delete: true,
      copy: true,
      upload: true,
      offlineLicense: true,
      instance: true,
    },
    {
      moduleName: 'installedSoftware',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'dashboard',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'version',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'submodule',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'user',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'dashboard',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'lock',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'platform',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'platformAlerts',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'systemEvent',
      read: true,
    },
    {
      moduleName: 'crashLog',
      read: true,
    },
    {
      moduleName: 'syslogSetting',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'MLScan',
      read: true,
      delete: true,
    },
    {
      moduleName: 'IntelligentModel',
      read: true,
    },
    {
      moduleName: 'licenseTemplate',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'licenseGenerate',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'ipFirewall',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'generalSettings',
      read: true,
    },
    {
      moduleName: 'general',
      create: true,
      read: true,
      update: true,
      delete: true,
    },
    {
      moduleName: 'cloudClient',
      create: true,
      read: true,
      update: true,
      delete: true,
      lock: true,
    },
    {
      moduleName: 'reSeller',
      create: true,
      read: true,
      update: true,
      delete: true,
    },

  ];

  const audienceType = process.env.REACT_APP_AUDIENCE_TYPE;
  const userType = constants.USER_TYPE.CLIENT;

  if (audienceType && (userType.toUpperCase()).trim() === audienceType.toUpperCase()) {
    // return only first two module
    modules = modules.splice(0, 9);
    modules = modules.map((item) => (
      {
        ...item,
        lock: false,
        copy: false,
        upload: false,
        create: !!(['clientUser', 'whiteListedIp'].includes(item.moduleName)),
        update: !!(['clientUser', 'whiteListedIp'].includes(item.moduleName)),
        delete: !!(['licenseInstance', 'clientUser', 'whiteListedIp'].includes(item.moduleName)),
      }
    ));
  }
  if (role === 'sales') {
    modules = [
      {
        moduleName: 'client',
        read: true,
      },
      {
        moduleName: 'cloudClient',
        read: true,
      },

      {
        moduleName: 'dashboard',
        read: true,
      },
      {
        moduleName: 'licenseManagement',
        read: true,
      },
      {
        moduleName: 'licenseGenerate',
        read: true,
      },
    ];
  }
  dispatch({
    type: USER.ROLE_LIST.SUCCESS,
    payload: modules,
  });
};

export default getUserRoles;
